import { getTypedBlocksByTypes } from '@/shared/helpers/compoundPattern'
import { Grid } from '@/shared/ui/layouts/grid'

import { type FC } from 'react'

import type { PageContentProps, PageProps } from './types'

type PageBlocksTypes = {
  PageContent: PageContentProps
}

export const PageRoot: FC<PageProps> = ({ children }) => {
  const { PageContent: pageContent, ...others } = getTypedBlocksByTypes<PageBlocksTypes>(children)

  const header = Object.values(others)
  const normalizedContent = header.length >= 1 ? <div>{header}</div> : null

  return (
    <Grid columns="1" gap="0" className="page">
      {normalizedContent}
      {pageContent}
    </Grid>
  )
}
